import { breakpoints } from './breakpoints';

type BreakpointKey = keyof typeof breakpoints.values;

export const theme = {
  breakpoints: {
    down: (key: BreakpointKey) =>
      `(max-width: ${breakpoints.values[key] - 0.02}px)`,
    up: (key: BreakpointKey) =>
      `(min-width: ${breakpoints.values[key]}px)`,
    between: (start: BreakpointKey, end: BreakpointKey) =>
      `(min-width: ${breakpoints.values[start]}px) and (max-width: ${
        breakpoints.values[end] - 0.02
      }px)`,
  },
}
